<section hlmCard aria-labelledby="partner-profile-title" class="mx-auto w-full max-w-md">
  <div hlmCardHeader>
    <h2 hlmCardTitle id="partner-profile-title">Fast geschafft</h2>
    <p hlmCardDescription>
      Unter welchem Namen trittst du auf? Deine Kunden sehen ihn, wenn du für sie ein Konto anlegst
      oder Zugriff anfragst.
    </p>
  </div>
  <div hlmCardContent>
    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6" novalidate>
      <div hlmField>
        <label hlmFieldLabel for="partner-profile-name">Dein Name oder der deiner Agentur</label>
        <input
          hlmInput
          id="partner-profile-name"
          formControlName="name"
          autocomplete="organization"
          placeholder="Agentur Nord"
          class="w-full"
          [attr.aria-invalid]="nameInvalid ? 'true' : null" />
        @if (nameInvalid) {
          <p hlmFieldDescription class="text-destructive">Bitte gib einen Namen an</p>
        }
      </div>

      @if (error()) {
        <div hlmAlert variant="destructive" role="alert">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
        </div>
      }

      <button
        hlmBtn
        type="submit"
        class="w-full"
        [disabled]="loading()"
        [attr.aria-busy]="loading()">
        @if (loading()) {
          <hlm-spinner />
        }
        Weiter
      </button>
    </form>
  </div>
</section>
